/**
 * Seed Configuration Constants
 *
 * Core seed configuration values including status colors, table settings,
 * and type/status labels.
 *
 * Migrated from: src/sections/seeds/config/constants.tsx
 * Migration: Phase 1, Task 5 - Section standardization
 *
 * Note: Renamed from constants.tsx to seedConfig.ts to avoid ambiguity
 */

import { SeedStatus } from '@/types';

/**
 * Seed status color mapping
 *
 * Used for visual styling of seed status indicators
 */
export const SEED_STATUS_COLORS = {
  [SeedStatus.Pending]: 'yellow',
  [SeedStatus.Accept]: 'green',
  [SeedStatus.Reject]: 'red',
  [SeedStatus.Freeze]: 'blue',
  [SeedStatus.Delete]: 'gray',
} as const;

/**
 * Default sort configuration for seeds table
 */
export const DEFAULT_SEED_SORT = {
  orderBy: 'created',
  descending: true,
} as const;

/**
 * Seed table configuration constants
 */
export const SEED_TABLE_CONFIG = {
  /** Default page size for seed table */
  defaultPageSize: 50,
  /** Available page size options */
  pageSizeOptions: [25, 50, 100, 200],
  /** Default selected columns (always visible) */
  defaultColumns: ['identifier'],
  /** Columns that cannot be sorted */
  disabledSortColumns: ['identifier'],
} as const;

/**
 * Keyboard shortcuts for seed actions
 */
export const SEED_KEYBOARD_SHORTCUTS = {
  approve: '⌥ A',
  reject: '⌥ R',
  freeze: '⌥ F',
  delete: '⌥ D',
} as const;

/**
 * Seed type labels for display
 */
export const SEED_TYPE_LABELS = {
  domain: 'Domain',
  ip: 'CIDR Range/IP',
  webapplication: 'Web Application',
  preseed: 'Preseed',
} as const;

/**
 * Seed status labels for display
 */
export const SEED_STATUS_LABELS = {
  [SeedStatus.Pending]: 'Pending',
  [SeedStatus.Accept]: 'Approved',
  [SeedStatus.Reject]: 'Rejected',
  [SeedStatus.Freeze]: 'Frozen',
  [SeedStatus.Delete]: 'Deleted',
} as const;
